import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse, PaginatedApiResponse } from '@card-software/library';
import _ from 'lodash';
import { InventorySearchCommand } from '../../models/inventory-summary';
import { InventorySummaryItemSearch, ItemMasterAvailable } from '../../models/item/item-master';
import { InventorySummarySearchCommand, InventorySummarySearchResult } from '../../models/inventory/inventory-summary-search';

@Injectable({
  providedIn: 'root',
})
export class InventorySummaryProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.inventoryApi + '/api/v1/inventory-summary';

  public inventorySummarySearchPage = signal<number>(1);
  public inventorySummarySearchPageSize = signal<number>(100);

  public itemSearch(
    searchCommand: InventorySummaryItemSearch,
    matchAny = false,
    consumableOnly = false,
    pageNumber = 1,
    pageSize = 100,
  ): Observable<ApiResponse<PaginatedApiResponse<ItemMasterAvailable>>> {
    return this.httpClient.post<ApiResponse<PaginatedApiResponse<ItemMasterAvailable>>>(
      `${this.baseUrl}/item/search?matchAny=${matchAny}&consumableOnly=${consumableOnly}&pageNumber=${pageNumber}&pageSize=${pageSize}`,
      searchCommand,
    );
  }

  public exportToExcel(searchCommand: InventorySearchCommand, queryLookUp?: string): Observable<Blob> {
    return this.httpClient.post(
      `${this.baseUrl}/export-excel${!_.isNil(queryLookUp) ? `?queryLookUp=${encodeURIComponent(queryLookUp)}` : ''}`,
      searchCommand,
      {
        responseType: 'blob',
      },
    );
  }

  public search(
    command: InventorySummarySearchCommand,
    pageNumber = 1,
    pageSize = 25,
    sortField?: string,
    sortOrder = -1,
  ): Observable<ApiResponse<InventorySummarySearchResult>> {
    let url = `${this.baseUrl}/search?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (sortField) {
      url += `&sortField=${encodeURIComponent(sortField)}&sortOrder=${sortOrder}`;
    }

    return this.httpClient.post<ApiResponse<InventorySummarySearchResult>>(url, command);
  }

  public exportToExcelPaginated(command: InventorySummarySearchCommand): Observable<Blob> {
    return this.httpClient.post(`${this.baseUrl}/search/export-excel`, command, {
      responseType: 'blob',
    });
  }

  public balanceAuditExport(
    locationCode: string,
    items: { itemCode: string; initialBalance: number; adjustment: number }[],
  ): Observable<Blob> {
    return this.httpClient.post(
      `${this.baseUrl}/balance-audit?locationCode=${encodeURIComponent(locationCode)}&export=true`,
      { items },
      { responseType: 'blob' },
    );
  }
}
